import {ApiAuthentication} from "~/data/usecases/authentication/apiAuthentication";
import {makeCache} from "~/main/factories/infra/cache";
import {makeHttpClient} from "~/main/factories/infra/http-client";

export const makeAuthenticationUseCases = () => {
  return new ApiAuthentication(makeHttpClient(), makeCache());
};
